import { brandSlugFromAuth } from "Services/authState";
import { getCsrfToken, CSRF_TOKEN_HEADER } from "Services/CsrfTokenService";

export type ApiHeaders = {
    Authorization: string;
    "Content-Type"?: string;
    "X-Brand": string;
    "X-Regal-Voice-Authorization": string;
    // DEPRECATE THIS
    "Api-Key": "Bearer Token";
    "X-Twilio-Authorization": "Bearer Token";
    [CSRF_TOKEN_HEADER]?: string;
};

/**
 * @todo (auth) Move those unnecessary headers to the API proxy.
 */
function generateApiHeaders({ brandSlug, csrfToken }: { brandSlug?: string; csrfToken?: string }) {
    return {
        ...(brandSlug ? { "X-Brand": brandSlug } : {}),
        ...(csrfToken ? { [CSRF_TOKEN_HEADER]: csrfToken } : {}),
        // Api-Key and X-Twilio-Authorization are not currently used, but ingest & voice still need there to be values for them
        "Api-Key": "Bearer Token",
        "X-Twilio-Authorization": "Bearer Token",
    };
}

export function apiHeaders(): ApiHeaders {
    const brandSlug = brandSlugFromAuth();
    const csrfToken = getCsrfToken();
    return generateApiHeaders({ brandSlug, csrfToken }) as ApiHeaders;
}
